import PropTypes from "prop-types";
import React from "react";
import { Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { Tooltip } from "../Tooltip";

const BulletedList = ({ items }) => {
  return (
    <List dense={true}>
      {items.map((item, index) => (
        <ListItem disableGutters={true} key={index}>
          <ListItemText
            primary={
              <Box display="flex" alignItems="center">
                <Box display="flex">
                  <Box component="span" pr={1} fontWeight="600" pt={0.4}>
                    &#8226;
                  </Box>
                  <Typography component="span">
                    {item.itemName && (
                      <Box component="span" fontWeight="600">
                        {item.itemName}{" "}
                      </Box>
                    )}
                    <Typography variant="body2">
                      {item.secondaryText}
                    </Typography>
                  </Typography>
                </Box>
                {item.tooltip && (
                  <Tooltip title={item.tooltip} interactive>
                    <Box ml={0.75} mb={0.25} display="flex" alignItems="center">
                      <InfoOutlined fontSize="small" color="action" />
                    </Box>
                  </Tooltip>
                )}
              </Box>
            }
          ></ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

BulletedList.propTypes = {
  /**
   * Called to close the Modal
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      tooltip: PropTypes.node
    })
  )
};

export default BulletedList;
